import * as React from 'react'
import * as AccordionPrimitive from '@radix-ui/react-accordion'
import { ChevronDown } from 'lucide-react'
import PropTypes from 'prop-types'

import { cn } from '../../lib/utils.js'

const Accordion = AccordionPrimitive.Root

const AccordionItem = React.forwardRef(({ className, ...props }, ref) => (
    <AccordionPrimitive.Item
        ref={ref}
        className={cn('border-none', className)}
        {...props}
    />
))
AccordionItem.displayName = 'AccordionItem'

const AccordionTrigger = React.forwardRef(({ className, children, hideIcon, headerChild, headerClassName, ...props }, ref) => (
    <AccordionPrimitive.Header  className={cn('flex', headerClassName)}>
        <AccordionPrimitive.Trigger
            ref={ref}
            className={cn(
                'flex flex-1 items-center justify-between py-4 font-medium transition-all [&[data-state=open]>svg]:rotate-180',
                className
            )}
            {...props}
        >
            {children}
            {!hideIcon && <ChevronDown className="h-4 w-4 text-primary shrink-0 transition-transform duration-200" />}
        </AccordionPrimitive.Trigger>
        {headerChild}
    </AccordionPrimitive.Header>
))
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName

const AccordionContent = React.forwardRef(({ className, children, ...props }, ref) => (
    <AccordionPrimitive.Content
        ref={ref}
        className="overflow-hidden text-sm transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
        {...props}
    >
        <div className={cn('pb-4 pt-0', className)}>{children}</div>
    </AccordionPrimitive.Content>
))

AccordionContent.displayName = AccordionPrimitive.Content.displayName

AccordionItem.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node

}

AccordionTrigger.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    hideIcon: PropTypes.bool,
    headerChild: PropTypes.node,
    headerClassName: PropTypes.string

}

AccordionContent.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node

}
export { Accordion, AccordionItem, AccordionTrigger, AccordionContent }
